import { FC } from "react";
import UploadAvatar from '../UploadAvatar';
import SearchFormItem from './subpage/searchFormItem';
import {
  BaseSearchFormItemProps,
  SearchFormItemEnum,
} from './interface/baseInterface';
import { UploadAvatarProps } from '../UploadAvatar/interface';

export interface SearchFormUploadAvatarProps extends BaseSearchFormItemProps {
  uploadAvatarProps?: UploadAvatarProps;
};
/** 上传图片（base64） */
const SearchFormUploadAvatar: FC<SearchFormUploadAvatarProps> = props => {
  const { isDetail, name, label, rules, uploadAvatarProps, disabledRender, ...restProps } = props;
  return (
    <SearchFormItem
      name={name}
      {...restProps}
      label={label}
      rules={rules}
      valuePropName="imageUrl"
    >
      <UploadAvatar
        {...uploadAvatarProps}
        disabled={isDetail || uploadAvatarProps?.disabled}
      />
    </SearchFormItem>
  );
};

SearchFormUploadAvatar.displayName = SearchFormItemEnum.SearchFormUploadAvatar;

export default SearchFormUploadAvatar;
